import { Box } from '@mui/material';
import React, { useState } from 'react';

const LazyImage = ({ src, sx, ...rest }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <Box
            component='img'
            src={src}
            loading='lazy'
            onLoad={() => setLoaded(true)}
            sx={[
                { transition: 'opacity 0.5s ease', opacity: loaded ? 1 : 0 },
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
            ]}
            {...rest}
        />
    );
};

export default LazyImage;
